async function getVariantMetafield(id,namespace,key){
    const guid = "gid://shopify/ProductVariant/" + id;
    const query = `
        query ProductMetafields($guid:ID!,$namespace:String!,$key:String!) {
            node(id:$guid) {
                ... on ProductVariant {
                    id
                    title
                    sku
                    meta:metafield(namespace: $namespace, key: $key) {
                        value
                        type
                        key
                    }
                }
            }
        }
    `;
    const variables = {guid,namespace,key};
    return await executeQuery(query,variables)
}
